import {Component, DoCheck, OnDestroy, OnInit} from '@angular/core';
import {EmpresaService} from "../../../services/empresa.service";
import {ConstantsService} from "../../ConstantsService";
import {AutorizacaoService} from "../../../services/autorizacao.service";
import moment from "moment";
import {Router} from "@angular/router";

@Component({
  selector: 'app-ativacao-meucardapio-pay-cellcoin',
  templateUrl: './ativacao-meucardapio-pay-cellcoin.component.html',
  styleUrls: ['./ativacao-meucardapio-pay-cellcoin.component.scss']
})
export class AtivacaoMeucardapioPayCellcoinComponent implements OnInit, DoCheck, OnDestroy {
  empresa: any;
  proposta: any = this.criePropostaVazia();
  indiceEtapa = 0;
  carregando = true;
  buscandoCnpj = false;
  enviando = false;
  migrando = false;
  concluido = false;
  mensagemErro: string;
  mensagemErroRodape: string;
  mensagemSucesso: string;
  propostaAtual: any;
  aguardandoProposta = false;
  modalWebhooksAberto = false;
  carregandoWebhooks = false;
  erroWebhooks: string;
  webhooksOnboarding: any;
  usuarioAdmin = false;
  modalTermoAceiteAberto = false;
  modalArquivosKycAberto = false;
  carregandoArquivosKyc = false;
  erroArquivosKyc = '';
  arquivosKyc: Array<any> = [];
  etapasConcluidas: any = {};
  etapasComValidacaoExibida: any = {};
  responsavelUsaTelefoneEmpresa = true;
  responsavelUsaEmailEmpresa = true;
  responsavelUsaEnderecoEmpresa = true;
  codigoPaisEmpresa = '+55';
  tipoDocumentoContaSelecionado: 'PF' | 'PJ' | null = null;
  termoAceito = false;
  termosUsoAberto = false;
  termosUsoLinkTremendo = false;
  termosUsoPopupAberto = false;
  termosUsoUrl = '/termos-de-uso-servicos-bancarios';
  private ultimoRascunhoSalvo: string;
  private pollingStatusProposta: any;
  private sincronizandoStatusAutomatico = false;

  passosAcompanhamento = [
    {id: 'dados', numero: 1, titulo: 'Dados enviados', descricao: 'Proposta criada'},
    {id: 'checagem', numero: 2, titulo: 'Checagem inicial', descricao: 'Análise cadastral em background'},
    {id: 'documentos', numero: 3, titulo: 'Validação facial', descricao: 'Foto e envio de documentos'},
    {id: 'conta', numero: 4, titulo: 'Conta de pagamento', descricao: 'Criação da conta de pagamento'},
    {id: 'pagamentos', numero: 5, titulo: 'Pix e Cartão', descricao: 'Liberação das formas de pagamento'}
  ];

  etapasBase = [
    {id: 'empresa', label: 'Conta', titulo: 'Dados da conta', subtitulo: 'Informe CPF ou CNPJ e complete os dados cadastrais.'},
    {id: 'endereco', label: 'Endereço', titulo: 'Endereço', subtitulo: 'Confirme o endereço vinculado à conta.'},
    {id: 'responsavel', label: 'Responsável', titulo: 'Responsável legal', subtitulo: 'Dados necessários para validar a conta de pagamento.'},
    {id: 'socios', label: 'Sócios', titulo: 'Sócios e representantes', subtitulo: 'Informe os sócios exigidos pela análise cadastral.'},
    {id: 'revisao', label: 'Revisão', titulo: 'Revisão final', subtitulo: 'Confira os dados antes de enviar a proposta.'}
  ];

  companyTypes = [
    {id: 'MEI', nome: 'MEI'},
    {id: 'ME', nome: 'Microempresa'},
    {id: 'PJ', nome: 'Pessoa jurídica'}
  ];

  ownerTypes = [
    {id: 'SOCIO', nome: 'Sócio responsável'},
    {id: 'REPRESENTANTE', nome: 'Representante legal'},
    {id: 'DEMAIS_SOCIOS', nome: 'Demais sócios'}
  ];

  respostasPep = [
    {valor: false, nome: 'Não'},
    {valor: true, nome: 'Sim'}
  ];

  constructor(private empresaService: EmpresaService,
              private constantsService: ConstantsService,  private router: Router,
              private autorizacaoService: AutorizacaoService) {}

  ngOnInit(): void {
    this.autorizacaoService.carregueUsuario().subscribe((usuario: any) => {
      this.usuarioAdmin = this.flagAtiva(usuario?.admin) || this.flagAtiva(usuario?.superadmin);
    });

    this.constantsService.empresa$.subscribe((empresa: any) => {
      if(empresa && !this.empresa)
        this.empresa = empresa;
    });

    this.empresaService.obtenhaPropostaCellcoin().then((payload: any) => {
      this.propostaAtual = payload?.cellcoinPropostaAtual || this.empresa?.meucardapioPay?.cellcoinPropostaAtual;
      this.aguardandoProposta = this.deveAcompanharProposta(this.propostaAtual);
      this.proposta = this.criePayloadAtivacao(payload || {});
      this.apliqueRascunhoLocal();
      this.sincronizeCodigosPaisTelefone();
      this.carregando = false;
      this.atualizePollingStatusProposta();
    }).catch((erro: any) => {
      this.mensagemErro = this.mensagemParaTela(erro);
      this.proposta = this.criePayloadAtivacao({});
      this.apliqueRascunhoLocal();
      this.sincronizeCodigosPaisTelefone();
      this.carregando = false;
      this.atualizePollingStatusProposta();
    });
  }

  ngDoCheck(): void {
    this.salvarRascunhoLocal();
  }

  ngOnDestroy(): void {
    this.parePollingStatusProposta();
  }

  etapas() {
    if(this.ehPessoaFisica() || this.proposta.companyType === 'MEI')
      return this.etapasBase.filter((etapa: any) => etapa.id !== 'socios');

    return this.etapasBase;
  }

  etapaAtual() {
    const etapas = this.etapas();
    if(this.indiceEtapa >= etapas.length)
      this.indiceEtapa = etapas.length - 1;

    return etapas[this.indiceEtapa];
  }

  progresso() {
    return ((this.indiceEtapa + 1) / this.etapas().length) * 100;
  }

  voltar() {
    this.mensagemErroRodape = '';
    if(this.indiceEtapa > 0)
      this.indiceEtapa--;
  }

  selecioneEtapa(index: number) {
    this.indiceEtapa = index;
  }

  etapaConcluida(etapa: any) {
    return !!this.etapasConcluidas[etapa?.id];
  }

  termoAceiteInvalido() {
    return this.validacaoVisivel('revisao') && !this.termoAceito;
  }

  registrouAberturaTermos() {
    this.termosUsoAberto = true;
    this.termosUsoPopupAberto = false;
  }

  abraTermosUso() {
    this.registrouAberturaTermos();
    window.open(this.termosUsoUrl, '_blank');
  }

  aoClicarAceiteTermos(event: Event) {
    if(this.termosUsoAberto)
      return;

    event.preventDefault();
    event.stopPropagation();
    this.termoAceito = false;
    this.termosUsoPopupAberto = true;
    this.tremeLinkTermosUso();
  }

  avancar() {
    this.mensagemErro = '';
    this.mensagemErroRodape = '';
    this.apliqueCamposCondicionais();

    const erro = this.valideEtapaAtual();
    if(erro){
      this.etapasComValidacaoExibida[this.etapaAtual().id] = true;
      if(this.etapaAtual().id === 'revisao')
        this.marqueEtapasInvalidas();
      this.mensagemErro = erro;
      return;
    }

    this.etapasConcluidas[this.etapaAtual().id] = true;

    if(this.etapaAtual().id === 'revisao')
      return this.enviar();

    this.indiceEtapa++;
  }

  voltePara(etapaId: string) {
    const index = this.etapas().findIndex((etapa: any) => etapa.id === etapaId);

    if(index >= 0){
      if(this.erroEtapa(etapaId))
        this.etapasComValidacaoExibida[etapaId] = true;
      this.indiceEtapa = index;
    }
  }

  mudouDocumento() {
    this.mensagemSucesso = '';
    const tamanhoDocumento = this.digitos(this.proposta.documentNumber).length;

    if(tamanhoDocumento === 11)
      this.tipoDocumentoContaSelecionado = 'PF';
    else if(tamanhoDocumento === 14)
      this.tipoDocumentoContaSelecionado = 'PJ';

    this.limpeConclusoesDocumentoConta();

    if(this.ehPessoaFisica()){
      const responsavel = this.ownerPrincipal();
      responsavel.documentNumber = this.digitos(this.proposta.documentNumber);
      this.responsavelUsaTelefoneEmpresa = false;
      this.responsavelUsaEmailEmpresa = false;
      this.responsavelUsaEnderecoEmpresa = true;
    } else if(this.proposta.companyType === 'PF') {
      this.proposta.companyType = 'PJ';
    }
  }

  mudouCompanyType() {
    if(this.ehPessoaFisica())
      return;

    if(this.proposta.companyType === 'MEI'){
      this.proposta.owner = [this.ownerPrincipal()];
      this.proposta.owner[0].ownerType = 'SOCIO';
    }

    const etapa = this.etapaAtual();
    if(etapa && etapa.id === 'socios' && this.proposta.companyType === 'MEI')
      this.indiceEtapa = this.etapas().findIndex((item: any) => item.id === 'endereco');
  }

  buscarCnpj() {
    this.mensagemErro = '';

    if(this.digitos(this.proposta.documentNumber).length !== 14){
      this.mensagemErro = 'Informe um CNPJ completo para buscar os dados.';
      return;
    }

    this.buscandoCnpj = true;
    this.empresaService.consulteCnpjCellcoin(this.proposta.documentNumber).then((sugestao: any) => {
      this.buscandoCnpj = false;
      this.apliqueSugestaoCnpj(sugestao);
      this.mensagemSucesso = 'Dados do CNPJ carregados para revisão.';
    }).catch((erro: any) => {
      this.buscandoCnpj = false;
      this.mensagemErro = this.mensagemParaTela(erro);
    });
  }

  ownerPrincipal() {
    this.proposta.owner = this.proposta.owner || [];
    if(!this.proposta.owner.length)
      this.proposta.owner.push(this.crieOwner('SOCIO'));

    return this.proposta.owner[0];
  }

  adicioneSocio() {
    this.proposta.owner = this.proposta.owner || [];
    this.proposta.owner.push(this.crieOwner('DEMAIS_SOCIOS'));
  }

  removaSocio(index: number) {
    if(index <= 0) return;
    this.proposta.owner.splice(index, 1);
  }

  enviar() {
    this.enviando = true;
    this.mensagemErro = '';
    this.mensagemErroRodape = '';
    this.apliqueCamposCondicionais();

    const payload = this.payloadParaEnvio();
    const requisicao = this.empresa?.meucardapioPay?.provedor === 'tuna' ?
      this.empresaService.migreEmpresaCellcoin(payload) :
      this.empresaService.registreEmpresaCellcoin(payload);

    requisicao.then((retorno: any) => {
      this.enviando = false;
      this.concluido = true;
      this.removaRascunhoLocal();

      if(this.empresa){
        this.empresa.meucardapioPay = retorno;
        this.propostaAtual = retorno?.cellcoinPropostaAtual;
        this.aguardandoProposta = this.deveAcompanharProposta(this.propostaAtual);
        this.constantsService.mudouEmpresa(this.empresa);
      }

      this.atualizePollingStatusProposta();
    }).catch((erro: any) => {
      this.enviando = false;
      this.mensagemErroRodape = this.mensagemParaTela(erro);
    });
  }

  abraValidacaoDocumentos() {
    const url = this.propostaAtual?.documentscopyUrl || this.empresa?.meucardapioPay?.cellcoinPropostaAtual?.documentscopyUrl;

    if(url)
      window.open(url, '_blank');
  }

  sincronizarPropostaAtual(silencioso = false) {
    if(this.enviando || this.sincronizandoStatusAutomatico) return;

    if(silencioso && !this.deveFazerPollingStatusProposta())
      return;

    if(silencioso)
      this.sincronizandoStatusAutomatico = true;
    else
      this.enviando = true;

    if(!silencioso)
      this.mensagemErro = '';
    this.empresaService.verifiqueRetornoRegistroCellcoin().then((retorno: any) => {
      this.enviando = false;
      this.sincronizandoStatusAutomatico = false;
      if(this.empresa){
        this.empresa.meucardapioPay = retorno;
        this.propostaAtual = retorno?.cellcoinPropostaAtual;
        this.aguardandoProposta = this.deveAcompanharProposta(this.propostaAtual);
        this.constantsService.mudouEmpresa(this.empresa);
      }

      this.atualizePollingStatusProposta();
    }).catch((erro: any) => {
      this.enviando = false;
      this.sincronizandoStatusAutomatico = false;

      if(silencioso){
        console.warn('Falha ao sincronizar proposta Cellcoin automaticamente', erro?.message || erro);
        return;
      }

      this.mensagemErro = this.mensagemParaTela(erro);
    });
  }

  comecarUsarCellcoin() {
    if(this.migrando || !this.podeComecarUsarCellcoin()) return;

    this.migrando = true;
    this.mensagemErro = '';
    this.mensagemSucesso = '';
    this.parePollingStatusProposta();

    this.empresaService.concluaMigracaoCellcoin().then((retorno: any) => {
      this.migrando = false;

      if(this.empresa){
        this.empresa.meucardapioPay = retorno;
        this.propostaAtual = retorno?.cellcoinPropostaAtual || this.propostaAtual;
        this.aguardandoProposta = this.deveAcompanharProposta(this.propostaAtual);
        this.constantsService.mudouEmpresa(this.empresa);
      }

      this.mensagemSucesso = 'Migração concluída. O Pix do Meu Cardápio Pay 2.0 está pronto para uso.';
      this.atualizePollingStatusProposta();
    }).catch((erro: any) => {
      this.migrando = false;
      this.mensagemErro = this.mensagemParaTela(erro);
      this.atualizePollingStatusProposta();
    });
  }

  fazerNovaProposta() {
    if(this.enviando) return;

    this.enviando = true;
    this.mensagemErro = '';
    this.mensagemSucesso = '';

    this.empresaService.crieNovaPropostaCellcoin().then((payload: any) => {
      this.enviando = false;
      this.concluido = false;
      this.propostaAtual = null;
      this.aguardandoProposta = false;
      this.etapasConcluidas = {};
      this.etapasComValidacaoExibida = {};
      this.indiceEtapa = 0;
      this.proposta = this.criePayloadAtivacao(payload || {});
      this.removaRascunhoLocal();
      this.mensagemSucesso = 'Preencha os dados para enviar uma nova proposta.';

      if(this.empresa?.meucardapioPay){
        this.empresa.meucardapioPay.cellcoinPropostaAtual = null;
        this.constantsService.mudouEmpresa(this.empresa);
      }
    }).catch((erro: any) => {
      this.enviando = false;
      this.mensagemErro = this.mensagemParaTela(erro);
    });
  }

  abrirWebhooksOnboarding() {
    if(this.carregandoWebhooks) return;

    this.modalWebhooksAberto = true;
    this.carregandoWebhooks = true;
    this.erroWebhooks = '';
    this.webhooksOnboarding = null;

    this.empresaService.listeWebhooksOnboardingCellcoin().then((retorno: any) => {
      this.carregandoWebhooks = false;
      this.webhooksOnboarding = retorno;
    }).catch((erro: any) => {
      this.carregandoWebhooks = false;
      this.erroWebhooks = this.mensagemParaTela(erro);
    });
  }

  fecharWebhooksOnboarding() {
    this.modalWebhooksAberto = false;
  }

  abrirDadosTermoAceite() {
    this.modalTermoAceiteAberto = true;
  }

  fecharDadosTermoAceite() {
    this.modalTermoAceiteAberto = false;
  }

  podeVerArquivosKyc() {
    const status = this.statusEtapaOnboarding('documentscopyStatus') ||
      String(this.propostaAcompanhamento()?.documentscopyStatus || '').toUpperCase();

    return this.usuarioAdmin && !!this.propostaAcompanhamento()?.proposalId &&
      ['PROCESSING', 'APPROVED', 'PROCESSING_DOCUMENTSCOPY'].indexOf(status) >= 0;
  }

  abrirArquivosKyc() {
    if(this.carregandoArquivosKyc) return;

    this.modalArquivosKycAberto = true;
    this.carregandoArquivosKyc = true;
    this.erroArquivosKyc = '';
    this.arquivosKyc = [];

    this.empresaService.obtenhaArquivosPropostaCellcoin().then((retorno: any) => {
      this.arquivosKyc = retorno?.files || [];
      this.carregandoArquivosKyc = false;
    }).catch((erro: any) => {
      this.erroArquivosKyc = this.mensagemParaTela(erro);
      this.carregandoArquivosKyc = false;
    });
  }

  fecharArquivosKyc() {
    this.modalArquivosKycAberto = false;
  }

  rotuloTipoArquivoKyc(tipo: string) {
    const rotulos: any = {
      CNH_FRONT: 'CNH - frente',
      CNH_BACK: 'CNH - verso',
      RG_FRONT: 'RG - frente',
      RG_BACK: 'RG - verso',
      RNE_FRONT: 'RNE - frente',
      RNE_BACK: 'RNE - verso',
      SELFIE: 'Selfie',
      CONTRATO_SOCIAL: 'Contrato social',
      DOCUMENTO_FINANCEIRO: 'Documento financeiro',
      PROCURACAO_PODERES: 'Procuração de poderes'
    };

    return rotulos[tipo] || tipo || 'Documento';
  }

  arquivoKycEhImagem(arquivo: any) {
    const tipo = String(arquivo?.type || '').toUpperCase();
    return ['CNH_FRONT', 'CNH_BACK', 'RG_FRONT', 'RG_BACK', 'RNE_FRONT', 'RNE_BACK', 'SELFIE']
      .indexOf(tipo) >= 0 || /\.(jpe?g|png)(\?|$)/i.test(String(arquivo?.url || ''));
  }

  dadosTermoAceite() {
    return this.propostaAcompanhamento() || {};
  }

  consultasWebhooksOnboarding() {
    return this.webhooksOnboarding?.consultas || [];
  }

  quantidadeWebhooksOnboarding() {
    return this.consultasWebhooksOnboarding()
      .reduce((total: number, consulta: any) => total + (consulta?.webhooks || []).length, 0);
  }

  semWebhookCreateDaPropostaAtual() {
    if(!this.webhooksOnboarding || this.carregandoWebhooks || this.quantidadeWebhooksOnboarding() === 0)
      return false;

    const consulta = this.consultasWebhooksOnboarding()
      .find((item: any) => item?.entity === 'onboarding-create');

    return !consulta || !(consulta.webhooks || []).length;
  }

  private flagAtiva(valor: any): boolean {
    return valor === true || valor === 1 || valor === '1' || valor?.data?.[0] === 1;
  }

  statusWebhookDetalhe(detalhe: any) {
    if(!detalhe) return 'Sem retorno';

    if(detalhe.httpStatusCode >= 200 && detalhe.httpStatusCode < 300)
      return 'Entregue';

    if(detalhe.status)
      return detalhe.status;

    return detalhe.httpStatusCode ? `HTTP ${detalhe.httpStatusCode}` : 'Pendente';
  }

  classeWebhookDetalhe(detalhe: any) {
    if(detalhe?.httpStatusCode >= 200 && detalhe.httpStatusCode < 300)
      return 'is-success';

    if(detalhe?.httpStatusCode || String(detalhe?.status || '').toUpperCase() === 'PENDENTE')
      return 'is-error';

    return 'is-pending';
  }

  formateJsonWebhook(valor: any) {
    if(!valor) return '';

    if(typeof valor === 'string')
      return valor;

    try {
      return JSON.stringify(valor, null, 2);
    } catch (erro) {
      return String(valor);
    }
  }

  voltarFormasPagamento() {
    this.router.navigate(['/admin/loja/formaspagamento/onlinemci']);
  }

  ownerLabel(index: number) {
    if(this.ehPessoaFisica())
      return 'Titular da conta';

    return index === 0 ? 'Responsável da validação' : `Sócio ${index + 1}`;
  }

  cpfMascarado(cpf: string) {
    const digitos = this.digitos(cpf);
    if(digitos.length !== 11) return 'CPF não informado';

    return `***.${digitos.substring(3, 6)}.${digitos.substring(6, 9)}-**`;
  }

  telefoneFormatado(telefone: any) {
    const digitos = this.telefoneNacional(telefone);

    if(digitos.length === 11)
      return `(${digitos.substring(0, 2)}) ${digitos.substring(2, 7)}-${digitos.substring(7)}`;

    if(digitos.length === 10)
      return `(${digitos.substring(0, 2)}) ${digitos.substring(2, 6)}-${digitos.substring(6)}`;

    return telefone || 'Telefone não informado';
  }

  telefoneResponsavelResumo() {
    if(this.ehPessoaFisica() || !this.responsavelUsaTelefoneEmpresa)
      return this.telefoneFormatado(this.ownerPrincipal().phoneNumber);

    return this.telefoneFormatado(this.proposta.contactNumber);
  }

  emailResponsavelResumo() {
    if(this.ehPessoaFisica() || !this.responsavelUsaEmailEmpresa)
      return this.ownerPrincipal().email || 'E-mail não informado';

    return this.proposta.businessEmail || 'E-mail não informado';
  }

  erroEtapa(etapaId: string) {
    if(etapaId === 'empresa')
      return this.valideDadosConta();

    if(etapaId === 'endereco')
      return this.valideEndereco(this.proposta.businessAddress, this.enderecoLabel());

    if(etapaId === 'responsavel')
      return this.valideOwner(this.ownerPrincipalParaValidacao(), 'responsável');

    if(etapaId === 'socios')
      return this.valideSociosParaRevisao();

    return null;
  }

  classeCardEtapa(etapaId: string) {
    return this.erroEtapa(etapaId) ? 'warning' : 'success';
  }

  statusCardEtapa(etapaId: string) {
    return this.erroEtapa(etapaId) ? 'Atenção' : 'Conferido';
  }

  quantidadeSociosAdicionais() {
    return Math.max((this.proposta.owner || []).length - 1, 0);
  }

  campoObrigatorioInvalido(etapaId: string, valor: any) {
    return this.validacaoVisivel(etapaId) && !valor;
  }

  nomeEmpresaInvalido(valor: any, tamanhoMaximo: number) {
    return this.validacaoVisivel('empresa') && !this.nomeEmpresaValido(valor, tamanhoMaximo);
  }

  nomeCompletoInvalido(etapaId: string, valor: any) {
    return this.validacaoVisivel(etapaId) && !this.nomeCompletoValido(valor);
  }

  documentoContaInvalido() {
    return this.validacaoVisivel('empresa') && !this.documentoContaValido();
  }

  cpfOwnerInvalido(owner: any, etapaId: string) {
    return this.validacaoVisivel(etapaId) && !this.cpfValido(owner?.documentNumber);
  }

  emailInvalido(etapaId: string, email: any) {
    return this.validacaoVisivel(etapaId) && !this.emailValido(email);
  }

  telefoneInvalido(etapaId: string, telefone: any, codigoPais = '+55') {
    return this.validacaoVisivel(etapaId) && !this.telefoneValido(telefone, codigoPais);
  }

  enderecoCampoInvalido(prefix: string, campo: string, endereco: any) {
    if(!this.validacaoVisivel(this.etapaEndereco(prefix))) return false;
    if(campo === 'postalCode') return this.digitos(endereco?.postalCode).length !== 8;
    if(campo === 'state') return !/^[A-Za-z]{2}$/.test(String(endereco?.state || '').trim());
    return !String(endereco?.[campo] || '').trim();
  }

  telefoneNacional(telefone: any, codigoPais = '+55') {
    const digitosTelefone = this.digitos(telefone);
    const digitosCodigoPais = this.digitos(codigoPais || '+55');

    if(digitosCodigoPais && digitosTelefone.indexOf(digitosCodigoPais) === 0)
      return digitosTelefone.substring(digitosCodigoPais.length);

    return digitosTelefone;
  }

  atualizeCodigoPaisEmpresa(codigoPais: string) {
    const telefoneAtual = this.telefoneNacional(this.proposta.contactNumber, this.codigoPaisEmpresa);
    this.codigoPaisEmpresa = codigoPais || '+55';
    this.proposta.contactNumber = this.telefoneComCodigoPais(telefoneAtual, this.codigoPaisEmpresa);
  }

  atualizeTelefoneEmpresa(telefone: string) {
    this.proposta.contactNumber = this.telefoneComCodigoPais(telefone, this.codigoPaisEmpresa);
  }

  atualizeCodigoPaisOwner(owner: any, codigoPais: string) {
    const telefoneAtual = this.telefoneNacional(owner.phoneNumber, owner.phoneCountryCode || '+55');
    owner.phoneCountryCode = codigoPais || '+55';
    owner.phoneNumber = this.telefoneComCodigoPais(telefoneAtual, owner.phoneCountryCode);
  }

  atualizeTelefoneOwner(owner: any, telefone: string) {
    owner.phoneCountryCode = owner.phoneCountryCode || '+55';
    owner.phoneNumber = this.telefoneComCodigoPais(telefone, owner.phoneCountryCode);
  }

  resumoEndereco(endereco: any) {
    if(!endereco) return 'Endereço não informado';

    return `${endereco.street || 'Logradouro'}, ${endereco.number || 'SN'} - ${endereco.city || 'Cidade'} ${endereco.state || ''}`;
  }

  nomeCompanyType() {
    if(this.ehPessoaFisica())
      return 'Pessoa física';

    const tipo = this.companyTypes.find((item: any) => item.id === this.proposta.companyType);

    return tipo ? tipo.nome : this.proposta.companyType;
  }

  documentoLabel() {
    if(this.ehPessoaFisica()) return 'CPF';
    if(this.ehPessoaJuridica()) return 'CNPJ';

    return 'CPF ou CNPJ';
  }

  mascaraDocumentoConta() {
    return this.ehPessoaJuridica() ? '00.000.000/0000-00' : '000.000.000-00';
  }

  labelAlternarDocumentoConta() {
    return this.ehPessoaFisica() ? 'Usar CNPJ' : 'Usar CPF';
  }

  alternarDocumentoConta() {
    if(this.ehPessoaFisica())
      return this.altereParaCnpjConta();

    return this.altereParaCpfConta();
  }

  textoAjudaDocumentoConta() {
    const tamanhoDocumento = this.digitos(this.proposta.documentNumber).length;

    if(tamanhoDocumento === 14)
      return this.cnpjValido(this.proposta.documentNumber) ?
        'CNPJ identificado. Confira os dados cadastrais antes de continuar.' : 'CNPJ inválido.';

    if(tamanhoDocumento === 11)
      return this.cpfValido(this.proposta.documentNumber) ?
        'CPF identificado. Continue para informar os dados do titular.' : 'CPF inválido.';

    if(this.ehPessoaJuridica())
      return 'Digite o CNPJ completo.';

    if(this.ehPessoaFisica())
      return 'Digite o CPF completo.';

    return 'Digite CPF ou CNPJ completo.';
  }

  documentoContaCompleto() {
    return this.documentoContaValido();
  }

  documentoFormatado(documento: any) {
    const digitos = this.digitos(documento);

    if(digitos.length === 11)
      return `${digitos.substring(0, 3)}.${digitos.substring(3, 6)}.${digitos.substring(6, 9)}-${digitos.substring(9)}`;

    if(digitos.length === 14)
      return `${digitos.substring(0, 2)}.${digitos.substring(2, 5)}.${digitos.substring(5, 8)}/${digitos.substring(8, 12)}-${digitos.substring(12)}`;

    return documento || 'não informado';
  }

  ehPessoaFisica() {
    const tamanhoDocumento = this.digitos(this.proposta.documentNumber).length;
    return tamanhoDocumento === 11 || (this.tipoDocumentoContaSelecionado === 'PF' && tamanhoDocumento !== 14);
  }

  ehPessoaJuridica() {
    const tamanhoDocumento = this.digitos(this.proposta.documentNumber).length;
    return tamanhoDocumento === 14 || (this.tipoDocumentoContaSelecionado === 'PJ' && tamanhoDocumento !== 11);
  }

  statusPropostaAtual() {
    const proposta = this.propostaAcompanhamento();
    const status = this.statusCellcoinPropostaAtual();

    if(!proposta) return '';

    if(this.propostaReprovada())
      return `Não aprovado - ${this.labelEtapaReprovacao()}`;

    if(this.migracaoTunaPendente() && this.contaCellcoinCriada())
      return 'Conta aprovada';

    if(this.contaCellcoinCriada())
      return 'Conta criada';

    if(this.documentoscopiaAprovada())
      return 'Aguardando criação da conta';

    if(this.documentoscopiaPendente() || status === 'PENDING_DOCUMENTSCOPY')
      return 'Aguardando validação facial/documentos';

    if(['CREATED', 'PENDING', 'APPROVED', 'PROCESSING', 'PROCESSING_DOCUMENTSCOPY'].indexOf(status) >= 0)
      return 'Checagem cadastral inicial';

    if(proposta.ativacaoStatus === '0')
      return 'Em análise';

    if(proposta.ativacaoStatus === 'P')
      return 'Processando';

    return proposta.cellcoinStatus || 'Pendente';
  }

  propostaAcompanhamento() {
    return this.propostaAtual || this.empresa?.meucardapioPay?.cellcoinPropostaAtual || null;
  }

  statusCellcoinPropostaAtual() {
    return String(this.propostaAcompanhamento()?.cellcoinStatus || '').toUpperCase();
  }

  resumoOnboarding() {
    return this.propostaAcompanhamento()?.onboardingResumo || {};
  }

  propostaReprovada() {
    const proposta = this.propostaAcompanhamento();
    const status = this.statusCellcoinPropostaAtual();

    return !!this.resumoOnboarding()?.rejectionEntity ||
      proposta?.ativacaoStatus === '2' ||
      ['REPROVED', 'ERROR', 'RESOURCE_ERROR'].indexOf(status) >= 0;
  }

  contaCellcoinCriada() {
    const proposta = this.propostaAcompanhamento();
    const meucardapioPay = this.empresa?.meucardapioPay || {};

    return Boolean(proposta?.account || meucardapioPay.cellcoinAccount?.account);
  }

  linkDocumentoscopiaDisponivel() {
    return Boolean(this.propostaAcompanhamento()?.documentscopyUrl);
  }

  documentoscopiaAprovada() {
    const proposta = this.propostaAcompanhamento();
    const status = this.statusEtapaOnboarding('documentscopyStatus') ||
      String(proposta?.documentscopyStatus || '').toUpperCase();

    return proposta?.documentscopyApproved === true || status === 'APPROVED';
  }

  documentoscopiaPendente() {
    const status = this.statusEtapaOnboarding('documentscopyStatus');
    return (this.linkDocumentoscopiaDisponivel() || !!status) &&
      !this.documentoscopiaAprovada() &&
      ['PENDING', 'PROCESSING', 'PENDING_DOCUMENTSCOPY', 'PROCESSING_DOCUMENTSCOPY'].indexOf(status || 'PENDING') >= 0;
  }

  etapaAtualAcompanhamento() {
    const etapaResumo = this.resumoOnboarding()?.currentStep;
    if(etapaResumo)
      return etapaResumo;

    if(this.propostaReprovada())
      return 'checagem';

    if(this.contaCellcoinCriada())
      return 'pagamentos';

    if(this.documentoscopiaAprovada())
      return 'conta';

    if(this.documentoscopiaPendente() || this.statusCellcoinPropostaAtual() === 'PENDING_DOCUMENTSCOPY')
      return 'documentos';

    return 'checagem';
  }

  classePassoAcompanhamento(passo: any) {
    if(this.propostaReprovada() && passo.id === this.etapaAtualAcompanhamento())
      return 'is-error';

    const atual = this.etapaAtualAcompanhamento();
    const indicePasso = this.passosAcompanhamento.findIndex((item: any) => item.id === passo.id);
    const indiceAtual = this.passosAcompanhamento.findIndex((item: any) => item.id === atual);

    if(indicePasso < indiceAtual)
      return 'is-done';

    if(indicePasso === indiceAtual)
      return 'is-current';

    return 'is-pending';
  }

  tituloAcompanhamento() {
    if(this.propostaReprovada()){
      const etapa = this.labelEtapaReprovacao();
      return etapa ? `${etapa} não aprovada` : 'Proposta não aprovada';
    }

    if(this.migracaoTunaPendente() && this.contaCellcoinCriada())
      return 'Conta aprovada e pronta para uso';

    if(this.contaCellcoinCriada())
      return 'Conta de pagamento criada';

    if(this.documentoscopiaAprovada())
      return 'Aguardando criação da conta de pagamento';

    if(this.documentoscopiaPendente())
      return 'Validação facial disponível';

    return 'Proposta enviada para análise inicial';
  }

  ondeEstamosAcompanhamento() {
    if(this.propostaReprovada())
      return this.mensagemOndeParouReprovacao();

    if(this.migracaoTunaPendente() && this.contaCellcoinCriada())
      return 'A conta de pagamento foi aprovada. Seus pagamentos continuam operando pela Tuna.';

    if(this.contaCellcoinCriada())
      return 'A conta de pagamento foi criada.';

    if(this.documentoscopiaAprovada())
      return 'A validação facial e os documentos foram aprovados.';

    if(this.documentoscopiaPendente())
      return 'O link de validação facial e envio de documentos já está disponível.';

    return 'A checagem cadastral inicial da proposta está sendo feita.';
  }

  aguardandoAcompanhamento() {
    if(this.propostaReprovada())
      return this.motivoReprovacao() || 'Revise os dados e envie uma nova proposta quando necessário.';

    if(this.migracaoTunaPendente() && this.contaCellcoinCriada())
      return this.propostaAcompanhamento()?.migrationError ||
        'Aguardando sua confirmação para trocar as formas de pagamento.';

    if(this.contaCellcoinCriada())
      return 'Agora falta liberar Pix e Cartão na tela de formas de pagamento.';

    if(this.documentoscopiaAprovada())
      return 'Aguardando a criação da conta de pagamento.';

    if(this.documentoscopiaPendente())
      return 'Aguardando o responsável concluir a validação facial e enviar os documentos.';

    return 'Aguardando a geração do link para validação facial e envio de documentos.';
  }

  proximoPassoAcompanhamento() {
    if(this.propostaReprovada())
      return `Corrija os dados da etapa ${this.labelEtapaReprovacao().toLowerCase()} e faça uma nova proposta.`;

    if(this.migracaoTunaPendente() && this.contaCellcoinCriada())
      return 'Clique em Começar a usar. O Pix e o cartão Tuna serão desativados e o Pix do Meu Cardápio Pay 2.0 será ativado.';

    if(this.contaCellcoinCriada())
      return 'Vá para formas de pagamento e libere Pix e Cartão em fluxos separados.';

    if(this.documentoscopiaAprovada())
      return 'Acompanhe a chegada do webhook de criação da conta ou consulte os webhooks enviados.';

    if(this.documentoscopiaPendente())
      return 'Abra o link de validação para tirar foto e enviar documentos.';

    return 'A tela verifica automaticamente a cada 30 segundos. Você também pode atualizar manualmente.';
  }

  podeAtualizarAcompanhamento() {
    return !this.propostaReprovada() && !this.contaCellcoinCriada();
  }

  podeIrParaFormasPagamento() {
    return this.contaCellcoinCriada() && !this.migracaoTunaPendente();
  }

  podeComecarUsarCellcoin() {
    return this.migracaoTunaPendente() && this.contaCellcoinCriada();
  }

  migracaoTunaPendente() {
    return this.empresa?.meucardapioPay?.provedor === 'tuna' && !!this.propostaAcompanhamento();
  }

  private statusEtapaOnboarding(campo: string) {
    const proposta = this.propostaAcompanhamento() || {};
    return String(this.resumoOnboarding()?.[campo] || proposta?.[campo] || '').toUpperCase();
  }

  private entityReprovacao() {
    const resumo = this.resumoOnboarding();

    if(resumo?.rejectionEntity)
      return String(resumo.rejectionEntity).toLowerCase();

    const status = this.statusCellcoinPropostaAtual();
    if(status === 'PENDING_DOCUMENTSCOPY' || status === 'PROCESSING_DOCUMENTSCOPY')
      return 'onboarding-documentscopy';

    return this.propostaReprovada() ? 'onboarding-proposal' : '';
  }

  private labelEtapaReprovacao() {
    const entity = this.entityReprovacao();

    if(entity.indexOf('onboarding-backgroundcheck') >= 0)
      return 'Checagem inicial';

    if(entity.indexOf('onboarding-documentscopy') >= 0)
      return 'Validação facial e documentos';

    if(entity.indexOf('onboarding-create') >= 0)
      return 'Criação da conta';

    return 'Proposta';
  }

  private mensagemOndeParouReprovacao() {
    const entity = this.entityReprovacao();

    if(entity.indexOf('onboarding-backgroundcheck') >= 0)
      return 'A checagem cadastral inicial não foi aprovada.';

    if(entity.indexOf('onboarding-documentscopy') >= 0)
      return 'A validação facial ou os documentos enviados não foram aprovados.';

    if(entity.indexOf('onboarding-create') >= 0)
      return 'Ocorreu um erro na criação da conta de pagamento.';

    return 'A análise final da proposta não foi aprovada.';
  }

  private motivoReprovacao() {
    return this.mensagemParaTela(
      this.resumoOnboarding()?.rejectionReason ||
      this.propostaAcompanhamento()?.rejectionReason ||
      this.propostaAcompanhamento()?.erro ||
      ''
    );
  }

  private mensagemParaTela(erro: any): string {
    const mensagem = erro?.mensagem || erro?.message || erro || '';
    return String(mensagem)
      .replace(/\bCellcoin\b/gi, '')
      .replace(/\s+([:,.])/g, '$1')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  deveExibirPollingStatusProposta() {
    return !!this.propostaAcompanhamento() && this.podeAtualizarAcompanhamento();
  }

  dataPropostaAtual() {
    const proposta = this.propostaAcompanhamento();
    return proposta?.atualizadoEm || proposta?.criadoEm;
  }

  enderecoLabel() {
    return this.ehPessoaFisica() ? 'endereço' : 'endereço comercial';
  }

  private criePayloadAtivacao(origem: any) {
    const documento = this.documentoInicialAtivacao(origem);
    const origemComDocumento = Object.assign({}, origem || {}, {documentNumber: documento});
    let payload: any;

    if(this.digitos(documento).length === 11)
      payload = this.criePayloadPessoaFisica(origemComDocumento);
    else
      payload = this.criePayloadPessoaJuridica(origemComDocumento);

    this.tipoDocumentoContaSelecionado = payload.companyType === 'PF' ? 'PF' : 'PJ';

    return payload;
  }

  private documentoInicialAtivacao(origem: any) {
    const documentoOrigem = this.digitos(origem?.documentNumber);
    if(documentoOrigem)
      return documentoOrigem;

    if(this.tipoDocumentoContaSelecionado === 'PJ')
      return this.digitos(this.empresa?.cnpj);

    if(this.tipoDocumentoContaSelecionado === 'PF')
      return this.digitos(origem?.owner?.[0]?.documentNumber) || this.digitos(this.empresa?.responsavel?.cpf);

    const cnpj = this.digitos(this.empresa?.cnpj);
    if(cnpj.length === 14)
      return cnpj;

    return this.digitos(origem?.owner?.[0]?.documentNumber) || this.digitos(this.empresa?.responsavel?.cpf);
  }

  private altereParaCpfConta() {
    const ownerAtual = this.ownerPrincipal();
    const documento = this.digitos(ownerAtual.documentNumber) || this.digitos(this.empresa?.responsavel?.cpf);
    const origem = Object.assign({}, this.proposta, {
      documentNumber: documento,
      owner: [Object.assign({}, ownerAtual, {documentNumber: documento})]
    });

    this.tipoDocumentoContaSelecionado = 'PF';
    this.proposta = this.criePayloadPessoaFisica(origem);
    this.tipoDocumentoContaSelecionado = 'PF';
    this.indiceEtapa = Math.min(this.indiceEtapa, this.etapas().length - 1);
    this.mudouDocumento();
  }

  private altereParaCnpjConta() {
    const ownerAtual = this.ownerPrincipal();
    const cpfResponsavel = this.digitos(ownerAtual.documentNumber) ||
      (this.ehPessoaFisica() ? this.digitos(this.proposta.documentNumber) : '') ||
      this.digitos(this.empresa?.responsavel?.cpf);
    const owners = (this.proposta.owner || [ownerAtual]).map((owner: any, index: number) => {
      if(index !== 0)
        return owner;

      return Object.assign({}, owner, {documentNumber: cpfResponsavel || owner.documentNumber});
    });
    const origem = Object.assign({}, this.proposta, {
      documentNumber: this.digitos(this.empresa?.cnpj),
      businessName: this.proposta.businessName || this.empresa?.razaoSocial || this.empresa?.nome || '',
      tradingName: this.proposta.tradingName || this.empresa?.nome || '',
      businessEmail: this.proposta.businessEmail || this.empresa?.email || '',
      contactNumber: this.proposta.contactNumber || this.telefoneEmpresa(),
      companyType: this.proposta.companyType && this.proposta.companyType !== 'PF' ? this.proposta.companyType : 'PJ',
      owner: owners
    });

    this.tipoDocumentoContaSelecionado = 'PJ';
    this.proposta = this.criePayloadPessoaJuridica(origem);
    this.tipoDocumentoContaSelecionado = 'PJ';
    this.indiceEtapa = Math.min(this.indiceEtapa, this.etapas().length - 1);
    this.mudouDocumento();
  }

  private limpeConclusoesDocumentoConta() {
    ['empresa', 'responsavel', 'socios', 'revisao'].forEach((etapa: string) => delete this.etapasConcluidas[etapa]);
  }

  private deveAcompanharProposta(proposta: any) {
    return !!proposta;
  }

  private iniciePollingStatusProposta() {
    if(this.pollingStatusProposta)
      return;

    if(!this.deveExibirPollingStatusProposta())
      return;

    this.pollingStatusProposta = setInterval(() => {
      this.sincronizarPropostaAtual(true);
    }, 30000);
  }

  private parePollingStatusProposta() {
    if(!this.pollingStatusProposta)
      return;

    clearInterval(this.pollingStatusProposta);
    this.pollingStatusProposta = null;
  }

  private deveFazerPollingStatusProposta() {
    return !this.carregando &&
      !this.enviando &&
      !this.sincronizandoStatusAutomatico &&
      this.deveExibirPollingStatusProposta();
  }

  private atualizePollingStatusProposta() {
    if(this.deveFazerPollingStatusProposta())
      this.iniciePollingStatusProposta();
    else
      this.parePollingStatusProposta();
  }

  private criePayloadPessoaJuridica(origem: any) {
    const businessAddress = origem.businessAddress || origem.address || {};
    const owner = origem.owner && origem.owner.length ? origem.owner : [this.crieOwner('SOCIO')];
    const documentoOrigem = this.digitos(origem.documentNumber);
    const documentNumber = documentoOrigem.length === 11 ? this.empresa?.cnpj || '' : origem.documentNumber || this.empresa?.cnpj || '';

    return {
      clientCode: origem.clientCode,
      contactNumber: origem.contactNumber || origem.phoneNumber || this.telefoneEmpresa(),
      documentNumber: documentNumber,
      businessEmail: origem.businessEmail || origem.email || this.empresa?.email || '',
      businessName: origem.businessName || this.empresa?.razaoSocial || this.empresa?.nome || '',
      tradingName: origem.tradingName || this.empresa?.nome || '',
      companyType: origem.companyType || 'PJ',
      owner: owner.map((item: any, index: number) => this.normalizeOwnerTela(item, index, businessAddress)),
      businessAddress: this.normalizeEnderecoTela(businessAddress),
      onboardingType: 'BAAS'
    };
  }

  private criePayloadPessoaFisica(origem: any) {
    const ownerOrigem = origem.owner && origem.owner.length ? origem.owner[0] : origem;
    const businessAddress = origem.businessAddress || origem.address || {};
    const documentoOrigem = this.digitos(origem.documentNumber);
    const documento = documentoOrigem.length === 14 ? ownerOrigem?.documentNumber || this.empresa?.responsavel?.cpf || '' : origem.documentNumber || ownerOrigem?.documentNumber || this.empresa?.responsavel?.cpf || '';
    const owner = this.normalizeOwnerTela(Object.assign({}, ownerOrigem || {}, {
      documentNumber: documento,
      fullName: ownerOrigem?.fullName || origem.fullName || this.empresa?.responsavel?.nome || this.empresa?.nome || '',
      phoneNumber: ownerOrigem?.phoneNumber || origem.phoneNumber || this.telefoneResponsavel(),
      email: ownerOrigem?.email || origem.email || this.empresa?.responsavel?.email || this.empresa?.email || '',
      motherName: ownerOrigem?.motherName || origem.motherName || this.empresa?.responsavel?.nomeMae || '',
      birthDate: ownerOrigem?.birthDate || origem.birthDate || this.empresa?.responsavel?.dataNascimento || '',
      isPoliticallyExposedPerson: origem.isPoliticallyExposedPerson === true || ownerOrigem?.isPoliticallyExposedPerson === true
    }), 0, businessAddress);

    return {
      clientCode: origem.clientCode,
      contactNumber: origem.contactNumber || origem.phoneNumber || this.telefoneResponsavel(),
      documentNumber: documento,
      businessEmail: origem.businessEmail || origem.email || this.empresa?.responsavel?.email || this.empresa?.email || '',
      businessName: '',
      tradingName: '',
      companyType: 'PF',
      owner: [owner],
      businessAddress: this.normalizeEnderecoTela(businessAddress),
      onboardingType: 'BAAS'
    };
  }

  private criePropostaVazia() {
    return {
      owner: [this.crieOwner('SOCIO')],
      businessAddress: {},
      companyType: 'PJ',
      onboardingType: 'BAAS'
    };
  }

  private crieOwner(ownerType: string) {
    return {
      ownerType: ownerType,
      documentNumber: '',
      fullName: '',
      phoneNumber: '',
      phoneCountryCode: '+55',
      email: '',
      birthDate: '',
      motherName: '',
      address: {},
      isPoliticallyExposedPerson: false,
      useBusinessAddress: true
    };
  }

  private normalizeOwnerTela(owner: any, index: number, endereco: any) {
    const normalizado = Object.assign(this.crieOwner(index === 0 ? 'SOCIO' : 'DEMAIS_SOCIOS'), owner || {});
    normalizado.address = this.normalizeEnderecoTela(normalizado.address || endereco || {});
    if(!normalizado.ownerType)
      normalizado.ownerType = index === 0 ? 'SOCIO' : 'DEMAIS_SOCIOS';
    if(normalizado.useBusinessAddress == null)
      normalizado.useBusinessAddress = true;
    delete normalizado.financialOwnerDetails;

    normalizado.birthDate = this.dataNascimentoParaTela(normalizado.birthDate);
    normalizado.phoneCountryCode = this.codigoPaisDoTelefone(normalizado.phoneNumber);
    normalizado.phoneNumber = this.telefoneComCodigoPais(normalizado.phoneNumber, normalizado.phoneCountryCode);

    return normalizado;
  }

  private normalizeEnderecoTela(endereco: any) {
    endereco = endereco || {};

    return {
      postalCode: endereco.postalCode || endereco.cep || '',
      street: endereco.street || endereco.logradouro || '',
      number: endereco.number || endereco.numero || '',
      addressComplement: endereco.addressComplement || endereco.complemento || '',
      neighborhood: endereco.neighborhood || endereco.bairro || '',
      city: endereco.city || endereco.cidadeNome || endereco.cidade?.nome || '',
      state: endereco.state || endereco.estado || endereco.cidade?.estado?.sigla || ''
    };
  }

  private apliqueSugestaoCnpj(sugestao: any) {
    this.proposta.documentNumber = sugestao.documentNumber || this.proposta.documentNumber;
    this.proposta.businessName = sugestao.businessName || this.proposta.businessName;
    this.proposta.tradingName = sugestao.tradingName || this.proposta.tradingName;
    this.proposta.businessEmail = sugestao.businessEmail || this.proposta.businessEmail;
    this.proposta.contactNumber = sugestao.contactNumber || this.proposta.contactNumber;
    this.codigoPaisEmpresa = this.codigoPaisDoTelefone(this.proposta.contactNumber);
    this.proposta.companyType = sugestao.companyType || this.proposta.companyType;
    this.proposta.businessAddress = this.normalizeEnderecoTela(Object.assign(
      {},
      this.proposta.businessAddress || {},
      sugestao.businessAddress || {}
    ));

    if(sugestao.owner && sugestao.owner.length){
      const ownerAtual = this.proposta.owner || [];
      this.proposta.owner = sugestao.owner.map((owner: any, index: number) => {
        return this.normalizeOwnerTela(Object.assign({}, ownerAtual[index] || {}, owner), index, this.proposta.businessAddress);
      });
    }

    this.mudouCompanyType();
  }

  private apliqueCamposCondicionais() {
    const responsavel = this.ownerPrincipal();

    if(this.ehPessoaFisica())
      responsavel.documentNumber = this.digitos(this.proposta.documentNumber);

    if(!this.ehPessoaFisica() && this.responsavelUsaTelefoneEmpresa)
      responsavel.phoneNumber = this.proposta.contactNumber;

    if(!this.ehPessoaFisica() && this.responsavelUsaEmailEmpresa)
      responsavel.email = this.proposta.businessEmail;

    if(this.responsavelUsaEnderecoEmpresa)
      responsavel.address = this.proposta.businessAddress;

    (this.proposta.owner || []).forEach((owner: any) => {
      if(owner.useBusinessAddress)
        owner.address = this.proposta.businessAddress;
    });

    if(this.proposta.companyType === 'MEI'){
      this.proposta.owner = [responsavel];
      responsavel.ownerType = 'SOCIO';
    }

    if(this.ehPessoaFisica()){
      this.proposta.owner = [responsavel];
      this.proposta.companyType = 'PF';
    }
  }

  private valideEtapaAtual() {
    const etapa = this.etapaAtual().id;

    if(etapa === 'empresa')
      return this.valideDadosConta();

    if(etapa === 'responsavel')
      return this.valideOwner(this.ownerPrincipal(), 'responsável');

    if(etapa === 'socios')
      return this.valideSocios();

    if(etapa === 'endereco')
      return this.valideEndereco(this.proposta.businessAddress, this.enderecoLabel());

    if(etapa === 'revisao')
      return this.valideTudo();

    return null;
  }

  private valideDadosConta() {
    const tamanhoDocumento = this.digitos(this.proposta.documentNumber).length;

    if(tamanhoDocumento !== 11 && tamanhoDocumento !== 14)
      return 'Informe um CPF ou CNPJ completo para continuar.';

    if(tamanhoDocumento === 11 && !this.cpfValido(this.proposta.documentNumber))
      return 'Informe um CPF válido para continuar.';

    if(tamanhoDocumento === 14 && !this.cnpjValido(this.proposta.documentNumber))
      return 'Informe um CNPJ válido para continuar.';

    if(this.ehPessoaFisica())
      return null;

    return this.valideEmpresa();
  }

  private valideEmpresa() {
    if(!this.nomeEmpresaValido(this.proposta.businessName, 350)) return 'Razão social contém caracteres não permitidos.';
    if(!this.nomeEmpresaValido(this.proposta.tradingName, 120)) return 'Nome fantasia contém caracteres não permitidos.';
    if(!this.emailValido(this.proposta.businessEmail)) return 'Informe um e-mail válido para a empresa.';
    if(!this.telefoneValido(this.proposta.contactNumber, this.codigoPaisEmpresa)) return 'Informe um telefone válido para a empresa.';
    if(!this.proposta.companyType) return 'Informe o tipo da empresa.';

    return null;
  }

  private valideSocios() {
    if(this.proposta.companyType === 'MEI')
      return null;

    for(let i = 1; i < (this.proposta.owner || []).length; i++){
      const erro = this.valideOwner(this.proposta.owner[i], `sócio ${i + 1}`);
      if(erro) return erro;
    }

    return null;
  }

  private valideSociosParaRevisao() {
    if(this.proposta.companyType === 'MEI')
      return null;

    for(let i = 1; i < (this.proposta.owner || []).length; i++){
      const owner = this.ownerParaValidacao(this.proposta.owner[i]);
      const erro = this.valideOwner(owner, `sócio ${i + 1}`);
      if(erro) return erro;
    }

    return null;
  }

  private valideTudo() {
    return this.valideDadosConta() ||
      this.valideEndereco(this.proposta.businessAddress, this.enderecoLabel()) ||
      this.valideOwner(this.ownerPrincipal(), 'responsável') ||
      this.valideSocios() ||
      this.valideTermosAceite();
  }

  private valideTermosAceite() {
    return this.termoAceito ? null : 'Aceite os Termos de Uso do Meu Cardapio antes de enviar a proposta.';
  }

  private valideOwner(owner: any, label: string) {
    if(!this.cpfValido(owner.documentNumber)) return `Informe um CPF válido para ${label}.`;
    if(!owner.fullName) return `Informe o nome de ${label}.`;
    if(!this.nomeCompletoValido(owner.fullName)) return `Informe nome e sobrenome de ${label}.`;
    if(!owner.birthDate) return `Informe a data de nascimento de ${label}.`;
    if(!owner.motherName) return `Informe o nome da mãe de ${label}.`;
    if(!this.nomeCompletoValido(owner.motherName)) return `Informe nome e sobrenome da mãe de ${label}.`;
    if(!this.telefoneValido(owner.phoneNumber, owner.phoneCountryCode || '+55')) return `Informe um telefone válido para ${label}.`;
    if(!this.emailValido(owner.email)) return `Informe um e-mail válido para ${label}.`;
    if(typeof owner.isPoliticallyExposedPerson !== 'boolean') return `Informe se ${label} é pessoa politicamente exposta.`;

    return this.valideEndereco(owner.address, `endereço de ${label}`);
  }

  private nomeCompletoValido(valor: any) {
    return String(valor || '').trim().split(/\s+/).filter((parte: string) => !!parte).length >= 2;
  }

  private nomeEmpresaValido(valor: any, tamanhoMaximo: number) {
    const nome = String(valor || '').trim();
    return !!nome && nome.length <= tamanhoMaximo &&
      /[A-Za-zÀ-ÖØ-öø-ÿ]/.test(nome) &&
      /^[A-Za-zÀ-ÖØ-öø-ÿ0-9 .,&'’"()\/-]+$/.test(nome);
  }

  private ownerPrincipalParaValidacao() {
    const owner = this.ownerParaValidacao(this.ownerPrincipal());

    if(this.ehPessoaFisica())
      owner.documentNumber = this.digitos(this.proposta.documentNumber);

    if(!this.ehPessoaFisica() && this.responsavelUsaTelefoneEmpresa)
      owner.phoneNumber = this.proposta.contactNumber;

    if(!this.ehPessoaFisica() && this.responsavelUsaEmailEmpresa)
      owner.email = this.proposta.businessEmail;

    if(this.responsavelUsaEnderecoEmpresa)
      owner.address = this.proposta.businessAddress;

    return owner;
  }

  private ownerParaValidacao(owner: any) {
    owner = Object.assign({}, owner || {});

    if(owner.useBusinessAddress)
      owner.address = this.proposta.businessAddress;

    return owner;
  }

  private valideEndereco(endereco: any, label: string) {
    if(this.digitos(endereco?.postalCode).length !== 8) return `Informe um CEP válido para o ${label}.`;
    if(!endereco?.street) return `Informe o logradouro do ${label}.`;
    if(!endereco?.number) return `Informe o número do ${label}.`;
    if(!endereco?.neighborhood) return `Informe o bairro do ${label}.`;
    if(!endereco?.city) return `Informe a cidade do ${label}.`;
    if(!/^[A-Za-z]{2}$/.test(String(endereco?.state || '').trim())) return `Informe uma UF válida para o ${label}.`;

    return null;
  }

  private documentoContaValido() {
    const documento = this.proposta.documentNumber;
    const tamanho = this.digitos(documento).length;
    return tamanho === 11 ? this.cpfValido(documento) : tamanho === 14 && this.cnpjValido(documento);
  }

  private cpfValido(valor: any) {
    const cpf = this.digitos(valor);
    if(cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    for(let posicao = 9; posicao < 11; posicao++){
      let soma = 0;
      for(let i = 0; i < posicao; i++)
        soma += Number(cpf.charAt(i)) * (posicao + 1 - i);

      let digito = (soma * 10) % 11;
      if(digito === 10) digito = 0;
      if(digito !== Number(cpf.charAt(posicao))) return false;
    }

    return true;
  }

  private cnpjValido(valor: any) {
    const cnpj = this.digitos(valor);
    if(cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

    const calculeDigito = (tamanho: number) => {
      let soma = 0;
      let peso = tamanho - 7;
      for(let i = 0; i < tamanho; i++){
        soma += Number(cnpj.charAt(i)) * peso--;
        if(peso < 2) peso = 9;
      }
      const resto = soma % 11;
      return resto < 2 ? 0 : 11 - resto;
    };

    return calculeDigito(12) === Number(cnpj.charAt(12)) &&
      calculeDigito(13) === Number(cnpj.charAt(13));
  }

  private emailValido(valor: any) {
    const email = String(valor || '').trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  private telefoneValido(valor: any, codigoPais = '+55') {
    const telefone = this.telefoneNacional(valor, codigoPais);
    const tamanho = this.digitos(telefone).length;
    return this.digitos(codigoPais) === '55' ?
      tamanho === 10 || tamanho === 11 : tamanho >= 6 && tamanho <= 15;
  }

  private payloadParaEnvio() {
    const payload = JSON.parse(JSON.stringify(this.proposta));
    this.removaCamposTemporariosTelefone(payload);
    this.removaCamposFinanceiros(payload);
    payload.termoAceito = this.termoAceito;

    if(!this.ehPessoaFisica())
      return this.normalizeDatasNascimentoPayload(payload);

    const owner = payload.owner && payload.owner.length ? payload.owner[0] : {};

    return {
      clientCode: payload.clientCode,
      documentNumber: this.digitos(payload.documentNumber || owner.documentNumber),
      phoneNumber: owner.phoneNumber || payload.contactNumber,
      email: owner.email || payload.businessEmail,
      motherName: owner.motherName,
      fullName: owner.fullName,
      socialName: owner.socialName || null,
      birthDate: this.formateDataNascimentoEnvio(owner.birthDate),
      address: owner.address || payload.businessAddress,
      isPoliticallyExposedPerson: owner.isPoliticallyExposedPerson,
      termoAceito: this.termoAceito,
      onboardingType: 'BAAS'
    };
  }

  private normalizeDatasNascimentoPayload(payload: any) {
    (payload.owner || []).forEach((owner: any) => {
      owner.birthDate = this.formateDataNascimentoEnvio(owner.birthDate);
    });

    if(payload.birthDate)
      payload.birthDate = this.formateDataNascimentoEnvio(payload.birthDate);

    return payload;
  }

  private dataNascimentoParaTela(valor: any): any {
    if(!valor || valor instanceof Date) return valor || null;

    const data = this.parseDataNascimento(valor);
    return data.isValid() ? data.toDate() : valor;
  }

  private formateDataNascimentoEnvio(valor: any): any {
    if(!valor) return valor;

    const data = this.parseDataNascimento(valor);
    return data.isValid() ? data.format('DD-MM-YYYY') : valor;
  }

  private parseDataNascimento(valor: any) {
    if(valor instanceof Date)
      return moment(valor);

    const texto = String(valor || '').trim();
    const formatos = ['DD-MM-YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD', 'YYYY/MM/DD', 'DDMMYYYY', 'YYYYMMDD'];
    const dataFormatada = moment(texto, formatos, true);

    if(dataFormatada.isValid())
      return dataFormatada;

    return moment(texto, moment.ISO_8601, true);
  }

  private telefoneEmpresa() {
    return this.empresa?.numeroWhatsapp?.whatsapp || this.empresa?.telefone || this.empresa?.celular || this.empresa?.whatsapp || '';
  }

  private telefoneResponsavel() {
    return this.empresa?.responsavel?.telefone || this.empresa?.responsavel?.celular || this.telefoneEmpresa();
  }

  private digitos(valor: any) {
    return String(valor || '').replace(/\D/g, '');
  }

  private validacaoVisivel(etapaId: string) {
    return !!this.etapasComValidacaoExibida[etapaId];
  }

  private etapaEndereco(prefix: string) {
    if(prefix === 'business')
      return 'endereco';

    return prefix === 'owner0' ? 'responsavel' : 'socios';
  }

  private salvarRascunhoLocal() {
    if(this.carregando || this.aguardandoProposta || this.concluido)
      return;

    const rascunho = this.crieRascunhoLocal();
    const json = JSON.stringify(rascunho);

    if(json === this.ultimoRascunhoSalvo)
      return;

    this.ultimoRascunhoSalvo = json;
    localStorage.setItem(this.chaveRascunhoLocal(), json);
  }

  private apliqueRascunhoLocal() {
    if(this.aguardandoProposta)
      return;

    const json = localStorage.getItem(this.chaveRascunhoLocal());
    if(!json)
      return;

    try {
      const rascunho = JSON.parse(json);
      if(!rascunho?.proposta)
        return;

      this.tipoDocumentoContaSelecionado = rascunho.tipoDocumentoContaSelecionado || null;
      this.proposta = this.criePayloadAtivacao(rascunho.proposta);
      this.indiceEtapa = Number(rascunho.indiceEtapa || 0);
      this.etapasConcluidas = rascunho.etapasConcluidas || {};
      this.etapasComValidacaoExibida = rascunho.etapasComValidacaoExibida || {};
      this.responsavelUsaTelefoneEmpresa = rascunho.responsavelUsaTelefoneEmpresa !== false;
      this.responsavelUsaEmailEmpresa = rascunho.responsavelUsaEmailEmpresa !== false;
      this.responsavelUsaEnderecoEmpresa = rascunho.responsavelUsaEnderecoEmpresa !== false;
      this.codigoPaisEmpresa = rascunho.codigoPaisEmpresa || '+55';
      this.termosUsoAberto = rascunho.termosUsoAberto === true || rascunho.termoAceito === true;
      this.termoAceito = rascunho.termoAceito === true && this.termosUsoAberto;
      this.ultimoRascunhoSalvo = JSON.stringify(rascunho);
    } catch (e) {
      localStorage.removeItem(this.chaveRascunhoLocal());
    }
  }

  private removaRascunhoLocal() {
    localStorage.removeItem(this.chaveRascunhoLocal());
    this.ultimoRascunhoSalvo = null;
  }

  private crieRascunhoLocal() {
    return {
      proposta: this.proposta,
      indiceEtapa: this.indiceEtapa,
      etapasConcluidas: this.etapasConcluidas,
      etapasComValidacaoExibida: this.etapasComValidacaoExibida,
      responsavelUsaTelefoneEmpresa: this.responsavelUsaTelefoneEmpresa,
      responsavelUsaEmailEmpresa: this.responsavelUsaEmailEmpresa,
      responsavelUsaEnderecoEmpresa: this.responsavelUsaEnderecoEmpresa,
      codigoPaisEmpresa: this.codigoPaisEmpresa,
      tipoDocumentoContaSelecionado: this.tipoDocumentoContaSelecionado,
      termosUsoAberto: this.termosUsoAberto,
      termoAceito: this.termoAceito
    };
  }

  private tremeLinkTermosUso() {
    this.termosUsoLinkTremendo = false;
    setTimeout(() => this.termosUsoLinkTremendo = true, 0);
    setTimeout(() => this.termosUsoLinkTremendo = false, 700);
  }

  private chaveRascunhoLocal() {
    const empresaId = this.empresa?.id || this.empresa?.dominio || 'sem-empresa';
    return `meucardapio-pay-cellcoin-ativacao-${empresaId}`;
  }

  private marqueEtapasInvalidas() {
    this.etapas().forEach((etapa: any) => {
      if(etapa.id !== 'revisao' && this.erroEtapa(etapa.id))
        this.etapasComValidacaoExibida[etapa.id] = true;
    });
  }

  private telefoneComCodigoPais(telefone: any, codigoPais = '+55') {
    const digitosTelefone = this.telefoneNacional(telefone, codigoPais);
    const codigo = codigoPais || '+55';

    return digitosTelefone ? `${codigo}${digitosTelefone}` : '';
  }

  private codigoPaisDoTelefone(telefone: any) {
    const digitosTelefone = this.digitos(telefone);

    if(digitosTelefone.indexOf('55') === 0)
      return '+55';

    return '+55';
  }

  private sincronizeCodigosPaisTelefone() {
    this.codigoPaisEmpresa = this.codigoPaisDoTelefone(this.proposta.contactNumber);

    (this.proposta.owner || []).forEach((owner: any) => {
      owner.phoneCountryCode = this.codigoPaisDoTelefone(owner.phoneNumber);
      owner.phoneNumber = this.telefoneComCodigoPais(owner.phoneNumber, owner.phoneCountryCode);
    });

    if(this.proposta.contactNumber)
      this.proposta.contactNumber = this.telefoneComCodigoPais(this.proposta.contactNumber, this.codigoPaisEmpresa);
  }

  private removaCamposTemporariosTelefone(payload: any) {
    (payload.owner || []).forEach((owner: any) => {
      delete owner.phoneCountryCode;
      delete owner.ownerIsLegalPerson;
      delete owner.useBusinessAddress;
    });
  }

  private removaCamposFinanceiros(payload: any) {
    delete payload.financialCompanyDetails;
    delete payload.financialDetails;

    (payload.owner || []).forEach((owner: any) => {
      delete owner.financialOwnerDetails;
    });
  }
}
